if (!customElements.get('ingredients-modal')) {
  customElements.define(
    'ingredients-modal',
    class IngredientsModal extends HTMLElement {
      constructor() {
        super();

        this.swiper = null;
        this.closeBtn = null;
        this.sectionId = null;
        this.openers = null;
        this.hasSlider = null;
      }

      connectedCallback() {
        this.closeBtn = this.querySelector('.ingredients-modal__close');
        this.sectionId = this.dataset.id;
        this.openers = document.querySelectorAll(`#Ingredient-cards-${this.sectionId} .ingridient-card__opener`);
        const tablet = window.matchMedia("(max-width: 749px)").matches;
        this.hasSlider = this.querySelector('.swiper') ? true : false;

        if (this.hasSlider) this.initSwiper();

        this.closeBtn.addEventListener('click', this.close.bind(this));
        this.addEventListener('click', (event) => {
          if (event.target === this) this.close();
        });

        if (this.openers && this.openers.length > 0) this.openers.forEach(el => {
          el.addEventListener('click', event => this.handleOpenerClick(event));
        });

        if (tablet) this.openAccordions();
      }

      open() {
        publish(PUB_SUB_EVENTS.modalToggle,  { display: false });
        lockBodyScroll();
        this.setAttribute('open', '');
      }

      close() {
        publish(PUB_SUB_EVENTS.modalToggle,  { display: true });
        unlockBodyScroll();
        this.removeAttribute('open');
      }

      handleOpenerClick(event) {
        const target = event.target.closest('.ingridient-card__opener');
        const index = target.dataset.index;

        if (this.swiper) {
          this.swiper.slideTo(index, 100);
        }

        this.open();
      }

      openAccordions() {
        this.querySelectorAll('.ingredient-slide').forEach(slide => {
          if (slide.querySelector('details')) slide.querySelector('details').setAttribute('open', '')
        });
      }

      initSwiper() {
        if (this.querySelector('.ingredients-slider')) {
          this.swiper = new Swiper('.ingredients-slider', {
            slidesPerView: 3,
            allowTouchMove: true,
            spaceBetween: 24,
            navigation: {
              nextEl: '.ingredients__next',
              prevEl: '.ingredients__prev',
            },
            breakpoints: {
              0: {
                slidesPerView: 1,
                centeredSlides: true,
                spaceBetween: 16,
              },
              750: {
                slidesPerView: 2,
                centeredSlides: false,
                spaceBetween: 24,
              },
              1024: {
                slidesPerView: 3,
              },
              1280: {
                slidesPerView: "auto"
              }
            }
          });
        }

        if (this.querySelector('.ingredients-slider-new')) {
          this.swiper = new Swiper('.ingredients-slider-new', {
            slidesPerView: 3,
            allowTouchMove: true,
            spaceBetween: 24,
            navigation: {
              nextEl: '.ingredients__next',
              prevEl: '.ingredients__prev',
            },
            breakpoints: {
              0: {
                slidesPerView: 1,
                centeredSlides: true,
                spaceBetween: 16,
              },
              750: {
                slidesPerView: 3,
                centeredSlides: false,
                spaceBetween: 24,
              }
            }
          });
        }
      }
    }
  );
}





